import { apiClient } from '@/api/client'
import type {
  Company,
  CompanyCreatePayload,
  CompanyListResponse,
  CompanyUpdatePayload,
  Organization,
  OrganizationCreatePayload,
  OrganizationUpdatePayload,
} from '@/features/organization/types'

export const organizationApi = {
  async me(): Promise<Organization> {
    const { data } = await apiClient.get<Organization>('/organizations/me')
    return data
  },
  async create(payload: OrganizationCreatePayload): Promise<Organization> {
    const { data } = await apiClient.post<Organization>('/organizations', payload)
    return data
  },
  async update(payload: OrganizationUpdatePayload): Promise<Organization> {
    const { data } = await apiClient.patch<Organization>('/organizations/me', payload)
    return data
  },
  async remove(): Promise<void> {
    await apiClient.delete('/organizations/me')
  },
}

export const companiesApi = {
  async list(params: { offset: number; limit: number; q?: string }): Promise<CompanyListResponse> {
    const { data } = await apiClient.get<CompanyListResponse>('/companies', { params })
    return data
  },
  async get(companyId: string): Promise<Company> {
    const { data } = await apiClient.get<Company>(`/companies/${companyId}`)
    return data
  },
  async create(payload: CompanyCreatePayload): Promise<Company> {
    const { data } = await apiClient.post<Company>('/companies', payload)
    return data
  },
  async update(companyId: string, payload: CompanyUpdatePayload): Promise<Company> {
    const { data } = await apiClient.put<Company>(`/companies/${companyId}`, payload)
    return data
  },
  async remove(companyId: string): Promise<void> {
    await apiClient.delete(`/companies/${companyId}`)
  },
}
